import { createContext } from 'react';

const AdminContext = createContext<any>({})

export default AdminContext